export default function () {
  this.map.flyTo([-128,128])
}